import { communicateApi } from 'services/http';

// Services
import { alertError } from 'services/alerts';

// mock data
// import { goals } from './mockData';

export const getJobsList = async (practitionerId) => {  
  return communicateApi.get(`practitioners/${practitionerId}/jobs`)
    .then(({ data }) => {
      if (Array.isArray(data)) {
        return data.sort((a, b) => {
          if (a.createdAt && b.createdAt) {
            return new Date(b.createdAt) - new Date(a.createdAt);
          }
        });
      }
      return data;
    })
    .catch((err) => {
      const { response } = err;
      if (response && response.status !== 401) {
        alertError();
        throw Error(err);
      }
    });
};


export const getGoals = async (url) => {
  return communicateApi.get(url)
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      const { response } = err;
      if (response && response.status !== 401) {
        alertError();
        throw Error(err);
      }
    });
};

export const getJob = async (url) => {
  return communicateApi.get(url)
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      const { response } = err;
      if (response && response.status !== 401) {
        alertError();
        throw Error(err);
      }
    });
};